<template>
  <div>
    <div
      class="viewCustom"
      style="height: 100vh"
      :class="listMedia.length > 1 ? 'hasSlide' : ''"
    >
      <v-btn
        fab
        color="#fff"
        @click.native="closeMediaPage"
        class="dialog-close"
      >
        <v-icon color="#000">fas fa-xmark</v-icon>
      </v-btn>
      <v-row no-gutters v-if="listMedia && listMedia.length !== 0">
        <v-col cols="12" :md="8" :lg="8">
          <div class="gallery-content">
            <template v-if="listMedia[model] && listMedia[model].youtubeId">
              <iframe
                width="100%"
                height="100%"
                :src="`https://www.youtube.com/embed/${listMedia[model].youtubeId}?autoplay=1`"
                frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowfullscreen
              >
              </iframe>
            </template>
            <v-img
              v-else-if="listMedia[model] && listMedia[model].thumbnail"
              :src="mediaDetail.path"
              contain
            ></v-img>
            <div class="nav-slider">
              <v-btn icon class="nav-next" @click.native="nextSlide">
                <v-icon>fas fa-circle-chevron-right</v-icon>
              </v-btn>
              <v-btn icon class="nav-prev" @click.native="prevSlide">
                <v-icon>fas fa-circle-chevron-left</v-icon>
              </v-btn>
            </div>
          </div>
        </v-col>
        <v-col cols="12" :md="4" :lg="4" v-if="listMedia[model]">
          <GalleryPanel :mediaDetail="mediaDetail" v-if="reInit" />
        </v-col>
      </v-row>
    </div>

    <GroupSlideMedia
      v-if="listMedia.length > 1"
      ref="slideGroup"
      :listMedia="listMedia"
      :model="model"
      @getSelectMedia="getSelectMedia"
      @nextListMedia="nextListMedia"
    />
  </div>
</template>
<script>
import { mapState } from "vuex";
import GroupSlideMedia from "@/components/Media/GroupSlideMedia";
import GalleryPanel from "@/components/Courses/GalleryPanel";
export default {
  name: "SlideMedia",
  components: {
    GroupSlideMedia,
    GalleryPanel,
  },
  props: {},
  data() {
    return {
      model: null,
      page: null,
      mediaDetail: {},
      reInit: true,
    };
  },
  async mounted() {
    this.model = this.idModel || 0;
    this.page =
      this.dataObj && this.dataObj.currentPage
        ? this.dataObj.currentPage
        : null;
    this.mediaDetail = await this.getMediaDetail();
  },
  computed: {
    ...mapState({
      idModel: (state) => state.toggle.idModel,
      listMedia: (state) => state.toggle.listMedia,
      dataObj: (state) => state.toggle.dataObj,
    }),
  },
  methods: {
    refresh() {
      this.reInit = false;
      this.$nextTick(() => {
        this.reInit = true;
      });
    },
    closeMediaPage() {
      this.$store.commit("closeMediaView");
    },
    async nextSlide() {
      if (this.model >= this.listMedia.length - 1) {
        if (this.page && this.page < this.dataObj.totalPages) {
          this.setListMedia();
          this.model += 1;
          this.mediaDetail = await this.getMediaDetail();
        }
      } else {
        this.model += 1;
        this.mediaDetail = await this.getMediaDetail();
      }
    },
    async prevSlide() {
      if (this.model === 0) {
        return;
      } else {
        this.model -= 1;
        this.mediaDetail = await this.getMediaDetail();
      }
    },
    async getSelectMedia(model) {
      this.model = model;
      this.mediaDetail = await this.getMediaDetail();
    },
    async nextListMedia() {
      const next = this.$refs.slideGroup.$refs.slideGroup.hasNext;
      if (next == false) {
        if (this.page && this.page < this.dataObj.totalPages) {
          this.setListMedia();
        } else return;
      } else return true;
    },
    async setListMedia() {
      this.page += 1;
      const page = this.page;
      const photo = await this.$store.dispatch("getListMedia", {
        type: MEDIA_TYPE_PHOTO,
        page,
      });
      const list = this.listMedia.concat(photo.list);
      this.$store.commit("setListMedia", list);
    },
    async getMediaDetail() {
      const media = this.listMedia[this.model];
      if (media) {
        const detail = await this.$store.dispatch("getMediaDetail", media.id);
        if(!window.cordova) {
          const type = media.type == MEDIA_TYPE_PHOTO ? "photo" : "video";
          history.pushState(
            {},
            null,
            `/${type}/${media.id}/course-media/${media.entityId}`
          );
        }
        this.refresh();
        return detail;
      } else return {};
    },
  },
};
</script>
<style lang="scss">
</style>